import { IndustryPage } from './IndustryPage'
import { industriesData } from '@/data/industries'

export default function Finance() {
  return <IndustryPage industry={industriesData.finance!} />
}
